import { Box, List, ListItemText } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import cs from 'classnames';
import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';
import { hasOneOfPermissions } from '../../../../shared/auth/permissionHelper';
import { usePermissions } from '../../../Session';
import { DrawerBodyProps } from './Mobile/DrawerBody';
import { useMenuItems } from './useMenuItems';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        itemContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '90px',
            paddingLeft: '24px',
            paddingRight: '24px',
            borderBottom: '1px solid #E6E5E5',
        },
        item: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: '#717073',
        },
        list: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
        },
        activeColor: {
            color: theme.palette.secondary.main,
        },
    })
);

const MenuList = ({ setOpen }: DrawerBodyProps) => {
    const history = useHistory();
    const location = useLocation();
    const permissions = usePermissions();
    const styles = useStyles();

    const redirect = useCallback(
        (route: string) => () => {
            history.push(route);
            setOpen(true);
        },
        [history, setOpen]
    );

    const getMenuStyles = useCallback(
        (path: string) =>
            location.pathname.toLowerCase() === path.toLowerCase() ? cs(styles.item, styles.activeColor) : styles.item,
        [location.pathname, styles.activeColor, styles.item]
    );

    const menuItems = useMenuItems();

    return (
        <List className={styles.list} component="nav">
            {menuItems
                .filter(
                    item =>
                        item.displayForBiometricSetting ||
                        hasOneOfPermissions(permissions, item.allowedPermissions || [])
                )
                .map(item => (
                    <Box key={item.to} className={styles.itemContainer} onClick={redirect(item.to)}>
                        <Box className={getMenuStyles(item.to)}>
                            <ListItemText primary={item.text} />
                            <ChevronRightIcon />
                        </Box>
                    </Box>
                ))}
        </List>
    );
};

export default MenuList;
